import { Delay, getDelay, createTimer } from './utils'

const runWithTimeout = <T = any>(
  promise: () => Promise<T>,
  time = 0
): Promise<T> => {
  let hasTimedout = false
  let timeout = null

  const runFn = (resolve, reject) => {
    const cb = () => {
      hasTimedout = true
      reject(new Error(`Exceeded timelimit of ${time} milliseconds.`))
    }

    timeout = createTimer(time, cb)

    promise()
      .then(response => {
        clearTimeout(timeout)
        if (!hasTimedout) {
          resolve(response)
        }
        return response
      })
      .catch(err => {
        reject(err)
      })
  }

  return new Promise((resolve, reject) => {
    runFn(resolve, reject)
  })
}

interface IOpts {
  delay?: Delay
  attempts?: number
  timeout?: number
}

const saferPromise = <T = any>(
  promise: () => Promise<T>,
  opts: IOpts
): Promise<T> => {
  const { delay, attempts, timeout } = opts
  let currentAttempt = 0

  return new Promise((resolve, reject) => {
    const rerun = res => {
      currentAttempt++

      if (currentAttempt < attempts) {
        const currentDelay = getDelay(delay, currentAttempt - 1)

        currentDelay ? setTimeout(run, currentDelay) : run()
      } else {
        reject(res)
      }
    }

    const run = () =>
      (timeout ? runWithTimeout<T>(promise, timeout) : promise())
        .then(resolve)
        .catch(rerun)
        .catch(reject)
    run()
  })
}

export { saferPromise }
